// extracted by mini-css-extract-plugin
module.exports = {"bulkActions":"bulkActions__Steif","container":"container__04Izg","text":"text__e8VEj","buttons":"buttons__Zong4"};